import { render, staticRenderFns } from "./NotificationsBox.vue?vue&type=template&id=d0b990ae&scoped=true&"
import script from "./NotificationsBox.vue?vue&type=script&lang=js&"
export * from "./NotificationsBox.vue?vue&type=script&lang=js&"
import style0 from "@/assets/styles/beneficiary.css?vue&type=style&index=0&id=d0b990ae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0b990ae",
  null
  
)

export default component.exports